export enum RequestState {
  IDLE = "IDLE",
  PENDING = "PENDING",
  FAILED = "FAILED",
  SUCCEEDED = "SUCCEEDED",
}
